import { inject, type InjectionKey, provide } from 'vue'
import { type FragmentType, graphql } from '~/resources/graphql'
import { AnalyticsCommitCheckoutResultFragment } from '~/composables/analytics/purchase-event'

export const KioskContractFragment = graphql(/* GraphQL */ `
    fragment KioskContractFragment on PlanContract {
        referenceNumber
        localizedName: publicName(language: $language)
        currentStatus
        savedFeesTotal
        savedDuesTotal
        terms {
            recurringConfiguration {
                billingInterval
            }
        }
        plan {
            terms {
                billingCycleString(language: $language)
            }
        }
    }
`)

export const KioskInvoiceFragment = graphql(/* GraphQL */ `
    fragment KioskInvoiceFragment on Invoice {
        subTotal
        total
        balanceRemaining
        salesTaxExclusive
        salesTaxInclusive
        friendlyBindings {
            amountAndFee
            isSubItem
            fee
        }
        lineItems {
            quantity
            unitPrice
            extendedPrice
            productVariant {
                description
            }
        }
    }
`)

export const KioskCheckoutResultFragment = graphql(/* GraphQL */ `
    fragment KioskCheckoutResultFragment on CommitCheckoutResult {
        contracts {
            __typename
            ... on PlanContract {
                ...KioskContractFragment
            }
        }
        invoice {
            ...KioskInvoiceFragment
        }
        ...AnalyticsCommitCheckoutResultFragment
    }
`)

export type KioskSuccessData = {
    contracts: FragmentType<typeof KioskContractFragment>[]
    invoice: FragmentType<typeof KioskInvoiceFragment> | null
    analytics?: FragmentType<typeof AnalyticsCommitCheckoutResultFragment>
}
export type KioskSuccessFunction = (data: KioskSuccessData) => void

const kioskSuccessInjectionKey: InjectionKey<KioskSuccessFunction> =
    Symbol('KIOSK_SUCCESS')
export function useKioskSuccess() {
    return inject(kioskSuccessInjectionKey, () => {
        throw new Error()
    })
}

export function provideKioskSuccessFunction(fn: KioskSuccessFunction) {
    provide(kioskSuccessInjectionKey, fn)
}
